import { call, put, takeEvery } from 'redux-saga/effects';

// Login Redux States
import { createUser, getAuthenticatedUser, getUserByEmail } from '../../../api/user';
import { toastError, toastSuccess } from '../../../helpers/toast-helper';
import {
	getAuthUserDetails,
	getAuthUserDetailsFail,
	getAuthUserDetailsSuccess,
	registerAuthUserFail,
	registerAuthUserSuccess,
} from './actions';
import { GET_USER_DETAILS, REGISTER_USER } from './actionTypes';

function* loadAuthUserByEmail(email) {
	if (!email) {
		return false;
	}

	try {
		const response = yield call(getUserByEmail, email);
		if (response?.success) {
			yield put(getAuthUserDetailsSuccess(response));
			return true;
		}
	} catch {
		// fall through
	}

	return false;
}

function* getAuthUserDetailsWorker({ payload: email }) {
	try {
		const response = yield call(getAuthenticatedUser);

		if (response?.success) {
			yield put(getAuthUserDetailsSuccess(response));
			return;
		}
	} catch {
		// GetAuthenticatedUser returns 404 when JWT email does not match DB; try explicit lookup.
	}

	if (yield call(loadAuthUserByEmail, email)) {
		return;
	}

	yield put(getAuthUserDetailsFail());
}

function* registerAuthUserWorker({ payload }) {
	try {
		const response = yield call(createUser, payload);

		if (response?.success) {
			yield put(registerAuthUserSuccess(response));
			toastSuccess('User was successfully registered');

			if (response?.data) {
				yield put(getAuthUserDetailsSuccess(response));
			} else {
				yield put(getAuthUserDetails(payload.email));
			}
		} else {
			if (yield call(loadAuthUserByEmail, payload?.email)) {
				yield put(registerAuthUserSuccess({ data: null }));
				return;
			}

			yield put(registerAuthUserFail(response?.errorMessage ?? response?.error));
		}
	} catch (error) {
		if (yield call(loadAuthUserByEmail, payload?.email)) {
			yield put(registerAuthUserSuccess({ data: null }));
			return;
		}

		yield put(registerAuthUserFail(error));
		toastError('Cannot register user');
	}
}

function* authSaga() {
	yield takeEvery(GET_USER_DETAILS, getAuthUserDetailsWorker);
	yield takeEvery(REGISTER_USER, registerAuthUserWorker);
}

export default authSaga;
